import * as React from 'react';

import { ClientTypeEditorView } from "./clienttype-editor.view";

interface ClientTypeEditorControllerProps {
    label?: string;
    value: number | null;
    onChanged: (value: number | null) => void;
    onGetErrorMessage?: () => Promise<ValidationError[]>;
    required?: boolean;
    mode: ControlMode;
}

export class ClientTypeEditorController extends React.Component<ClientTypeEditorControllerProps, any> {
    public constructor(props) {
        super(props);
    }

    public render() {
        return (
            <ClientTypeEditorView {...this.props} />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/crm/clients/parts/clienttype-editor.controller.tsx